const MultiplierSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
      <g clip-path="url(#clip0_8983_22690)">
        <path
          d="M0.460938 5.20259L2.94322 2.72031L4.16094 3.93859L7.17237 0.927734"
          stroke="#D5D5D5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.48093 1.85603C7.53064 1.36232 7.53064 1.09089 7.48093 0.618888C7.00893 0.569746 6.73807 0.569746 6.24379 0.618888M2.62321 7.48517V4.79832M5.09921 7.48517V4.79832M0.4375 6.64517L0.5495 7.48517H7.3935L7.55179 3.7206"
          stroke="#D5D5D5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8983_22690">
          <rect width="8" height="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MultiplierSvg;
